import type { StatusAgg } from "@/types/autosped";

type Tone = "success" | "warning" | "danger" | "muted" | "arq" | "onb";

/** Status agregado da empresa → pill (espelha statusPill do design). */
export function statusAggPill(s: StatusAgg): { tone: Tone; label: string } {
  switch (s) {
    case "concluido":
      return { tone: "success", label: "Concluído" };
    case "parcial":
      return { tone: "warning", label: "Concluído com falhas" };
    case "processando":
      return { tone: "onb", label: "Em processamento" };
    case "erro":
      return { tone: "danger", label: "Com erro" };
    case "pendente":
      return { tone: "arq", label: "Pendente" };
    default:
      return { tone: "muted", label: s };
  }
}

/** Status de um arquivo SPED → pill. */
export function fileStatusPill(s: string): { tone: Tone; label: string } {
  switch (s) {
    case "baixado":
      return { tone: "success", label: "Concluído" };
    case "enviado_importacao":
      return { tone: "success", label: "Enviado p/ importação" };
    case "ignorado_ja_processado":
      return { tone: "muted", label: "Ignorado (já baixado)" };
    case "pendente":
      return { tone: "arq", label: "Pendente" };
    case "erro":
      return { tone: "danger", label: "Com erro" };
    default:
      return { tone: "muted", label: s };
  }
}

export function origemLabel(o: string | null): string {
  return o === "ecac" ? "e-CAC" : o === "importacao" ? "Importação" : "—";
}

export function formatBytes(n: number | null): string {
  if (n == null) return "—";
  if (n < 1024) return `${n} B`;
  const units = ["KB", "MB", "GB", "TB"];
  let value = n / 1024;
  let i = 0;
  while (value >= 1024 && i < units.length - 1) {
    value /= 1024;
    i += 1;
  }
  return `${value < 10 ? value.toFixed(1) : Math.round(value)} ${units[i]}`;
}

export function formatDateTime(iso: string | null): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  const pad = (x: number) => String(x).padStart(2, "0");
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
